import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { dsokCustomerDetailMenuItems } from "../../components/dsokCustomerDetailMenuConfig";

/**
 * Generic section box for DSOK customer detail config areas.
 * Renders a card with icon, translated title, optional description, and click handler.
 * Navigation uses the same pathBuilder as the top menu for each section.
 */
const ConfigSectionBox = ({
  sectionId,
  labelKey,
  descriptionKey,
  icon: Icon,
  customerUrl,
  mode,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isReadOnly = mode === "read";

  const handleClick = () => {
    if (!customerUrl) return;
    const menuItem = dsokCustomerDetailMenuItems.find((item) => item.id === sectionId);
    if (menuItem?.pathBuilder) {
      navigate(menuItem.pathBuilder(customerUrl));
    }
  };

  return (
    <Card
      variant="outlined"
      onClick={handleClick}
      sx={{
        height: "100%",
        cursor: "pointer",
        opacity: isReadOnly ? 0.92 : 1,
        transition: "box-shadow 0.2s, background-color 0.2s",
        "&:hover": {
          boxShadow: 1,
          bgcolor: "action.hover",
        },
        "& .MuiCardContent-root": {
          pointerEvents: isReadOnly ? "none" : "auto",
        },
      }}
    >
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 48,
              height: 48,
              borderRadius: 1,
              bgcolor: "action.hover",
              flexShrink: 0,
            }}
          >
            {Icon && <Icon sx={{ fontSize: 28, color: "primary.main" }} />}
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="h6" component="h2" gutterBottom>
              {labelKey ? t(labelKey) : ""}
            </Typography>
            {descriptionKey && (
              <Typography variant="body2" color="text.secondary">
                {t(descriptionKey)}
              </Typography>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ConfigSectionBox;
